import React, { memo, useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Anchor from 'components/Ui/Anchor';
import { useBrand } from 'components/Brands/hooks';
import { getLogoByBrand } from 'components/Logos/byBrand';

const Logo = ({ anchor, link, to, className }) => {
  const brand = useBrand();
  const [logo, setLogo] = useState();

  const fetchLogo = useCallback(async () => {
    if (!brand) return;
    const foundLogo = await getLogoByBrand(brand);
    setLogo(foundLogo);
  }, [brand]);

  useEffect(() => {
    fetchLogo();
  }, [fetchLogo]);

  if (!brand || !logo?.file) return null;

  const img = <img src={logo.file.url} alt={logo.description} />;

  if (to && (anchor || link)) {
    const A = anchor ? Anchor : Link;

    return (
      <A to={to} className={className}>
        {img}
      </A>
    );
  }

  return img;
};

Logo.propTypes = {
  anchor: PropTypes.bool,
  link: PropTypes.bool,
  to: PropTypes.string,
  className: PropTypes.string,
};

export default memo(Logo);
